import { Box } from '@bechtel/gds';
import { FC } from 'react';
import { Skeleton } from '../skeleton';

interface FormSkeletonProps {
  columns?: number;
  rows?: number;
}

export const FormSkeleton: FC<FormSkeletonProps> = ({ columns = 2, rows = 40 }) => {
  return (
    <Box flexGrow={{ sm: '1' }} py={{ sm: '450' }} px={{ sm: '700' }} style={{ gap: '60px' }}>
      {Array.from({ length: columns }).map((item, index) => {
        return (
          <Box
            flexDirection={{ sm: 'column' }}
            key={index}
            style={{ width: '50%', display: 'block', overflowY: 'hidden' }}
          >
            {Array.from({ length: rows }).map((item, index) => {
              return <FormRowSkeleton key={index}></FormRowSkeleton>;
            })}
          </Box>
        );
      })}
    </Box>
  );
};

const FormRowSkeleton = () => {
  return (
    <Box gap={{ sm: '200' }} mb={{ sm: '450' }} style={{ height: '30px' }}>
      <Skeleton width="20%" borderRadius="200" />
      <Skeleton width="90%" borderRadius="200" />
    </Box>
  );
};
